<template>
<div :class="bem()">
    <div :class="bem('title')">
        <div :class="bem('title-main')">
            <div>微信扫码登录注册</div>
        </div>
        <div v-if="!vm.currentUser" :class="bem('title-tip')">
            <p>登录开启设计新世界</p>
        </div>
        <div v-else :class="bem('title-tip')">
            <p>请使用手机微信扫描二维码，</p>
            <p>或点击头像授权登录。</p>
        </div>
    </div>
    <div v-if="!vm.currentUser" :class="bem('qrcode-wrapper', 'single')">
        <div :class="bem('message')" v-if="loading">
            <span>生成二维码中...</span>
        </div>
        <template v-else-if="error">
            <div :class="[bem('message'), bem('message-error')]">
                二维码生成失败
                <Button type="primary" @click="createWechatQrcode">点击重试</Button>
            </div>
            <div :class="bem('tips')">扫描登录遇到问题？请联系客服</div>
        </template>
        <template v-else>
            <qrcode :class="bem('qrcode')" :value="qrcodeUrl" :options="qrcodeOption" />
            <!-- <div :class="bem('tips')">{{QRCodeCaption}}</div> -->
        </template>
    </div>
    <div v-else :class="bem('qrcode-wrapper', 'multiple')">
        <div :class="bem('small-qrcode')">
            <div :class="bem('small-qrcode-loading')" v-if="loading">
                生成二维码中...
            </div>
            <div v-else-if="error" :class="bem('small-qrcode-error')">
                <span>生成失败</span>
                <Button type="primary" size="mini" @click="createWechatQrcode">点击重试</Button>
            </div>
            <qrcode v-else :class="bem('small-qrcode-code')" :value="qrcodeUrl" :options="qrcodeOption" />
        </div>
        <div :class="bem('user')">
            <div :class="bem('user-avatar')" @click="quickLogin">
                <img :src="vm.currentUser.avatar" alt="">
            </div>
            <div :class="bem('user-name')" :title="vm.currentUser.nick">{{vm.currentUser.nick}}</div>
            <div :class="bem('user-id')">ID:{{vm.currentUser.id}}</div>
        </div>
    </div>
    <!-- 其它方式登录 -->
    <OtherWayLogin type='phone' />
</div>

</template>
<script>
import _Button from "@gaoding/gdui/lib/button";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Qrcode from '@xkeshi/vue-qrcode';
import { sessionCache } from '@gaoding/cache';
import bemMixin from './bem';
import OtherWayLogin from './OtherWayLogin.vue';
export default {
  name: 'g-auth-wechat',
  components: {
    Button: _Button,
    Qrcode: Qrcode,
    OtherWayLogin: OtherWayLogin
  },
  mixins: [bemMixin],
  inject: ['vm'],
  props: {
    QRCodeCaption: {
      type: String,
      default: '关注"稿定设计官方服务号"进行注册'
    }
  },
  data: function data() {
    return {
      qrcodeUrl: '',
      qrcodeOption: {
        size: 190
      },
      loading: false,
      error: false
    };
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.success && this.qrcodeUrl && this.qrcodeId) {
      sessionCache.set('wechat-qrcode', {
        url: this.qrcodeUrl,
        id: this.qrcodeId
      }, {
        time: '8m'
      });
    } else {
      sessionCache.remove('wechat-qrcode');
    }

    this.clearTimer();
  },
  methods: {
    init: function init() {
      var data = sessionCache.get('wechat-qrcode');

      if (data) {
        this.qrcodeUrl = data.url;
        this.qrcodeId = data.id;
        this.queryWechatStatus(data.id);
      } else {
        this.createWechatQrcode();
      }
    },
    createWechatQrcode: function createWechatQrcode() {
      var _this = this;

      this.loading = true;
      this.error = false;
      this.clearTimer();
      this.vm.requestUms('createWechatQrcode', {
        native: 1
      }).then(function (res) {
        _this.qrcodeUrl = res.url;
        _this.qrcodeId = res.id;
        _this.loading = false;

        _this.queryWechatStatus(res.id);
      }).catch(function (e) {
        _this.vm.$emit('error', {
          error: e,
          action: 'login',
          type: 'wechat'
        });

        _this.loading = false;
        _this.error = true;
      });
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.queryTimer);
    },
    queryWechatStatus: function queryWechatStatus(id) {
      var _this2 = this;

      this.queryTimer = setTimeout(function () {
        _this2.vm.requestUms('queryWechatStatus', {
          id: id
        }).then(function (res) {
          if (res.result !== 0) {
            _this2.clearTimer();
          }

          switch (res.result) {
            case 1:
              _this2.vm.bindphoneType = 'wechat';
              _this2.success = true;

              _this2.vm.switchType('bindphone');

              break;

            case 2:
              _this2.success = true;

              _this2.vm.requestUms('authorizationCodeLogin', {
                code: res.authorization_code
              }).then(function () {
                _this2.vm.onLogin('wechat');
              }).catch(function (error) {
                _this2.vm.$emit('error', {
                  error: error,
                  action: 'login',
                  type: 'wechat'
                });
              });

              break;

            case 3:
              _this2.createWechatQrcode();

              break;

            default:
              _this2.queryWechatStatus(id);

              break;
          }
        }).catch(function (e) {
          _this2.vm.$emit('error', {
            error: e,
            action: 'login',
            type: 'wechat'
          });

          _this2.createWechatQrcode();
        });
      }, 1000);
    },
    quickLogin: function quickLogin() {
      var _this3 = this;

      this.vm.requestUms('quickLogin').then(function () {
        _this3.vm.onLogin('quickLogin');
      }).catch(function (error) {
        _this3.vm.$emit('error', {
          error: error,
          action: 'login',
          type: 'quickLogin'
        });
      });
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-wechat {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}
.g-auth-wechat .g-auth-wechat__title-main {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 20px;
  font-size: 20px;
  font-weight: 500;
  height: 20px;
  color: #000;
}
.g-auth-wechat .g-auth-wechat__icon-wechat {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.g-auth-wechat .g-auth-wechat__title-tip {
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  color: #636C78;
}
.g-auth-wechat .g-auth-wechat__title-tip p {
  margin: 0;
}
.g-auth-wechat .g-auth-wechat__small-qrcode {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dadde1;
  transition: box-shadow 0.3s ease;
}
.g-auth-wechat .g-auth-wechat__small-qrcode:hover {
  cursor: pointer;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.16);
}
.g-auth-wechat .g-auth-wechat__small-qrcode-loading {
  font-size: 12px;
  color: #000;
}
.g-auth-wechat .g-auth-wechat__small-qrcode-error {
  text-align: center;
  font-size: 12px;
  color: #000;
}
.g-auth-wechat .g-auth-wechat__small-qrcode-error button {
  margin-top: 4px;
}
.g-auth-wechat .g-auth-wechat__small-qrcode-code {
  display: block;
  width: 90px;
  height: 90px;
}
.g-auth-wechat .g-auth-wechat__user {
  margin-left: 12px;
  width: 100px;
}
.g-auth-wechat .g-auth-wechat__user-avatar {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dadde1;
  transition: box-shadow 0.3s ease;
}
.g-auth-wechat .g-auth-wechat__user-avatar img {
  display: block;
  width: 90px;
  height: 90px;
}
.g-auth-wechat .g-auth-wechat__user-avatar:hover {
  cursor: pointer;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.16);
}
.g-auth-wechat .g-auth-wechat__user-name {
  margin-top: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #444950;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.g-auth-wechat .g-auth-wechat__user-id {
  font-size: 12px;
  line-height: 16px;
  color: #8D949E;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.g-auth-wechat .g-auth-wechat__qrcode-wrapper--single {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  margin-top: 24px;
  margin-bottom: 50px;
}
.g-auth-wechat .g-auth-wechat__qrcode-wrapper--multiple {
  margin-top: 28px;
  display: flex;
  justify-content: space-around;
  margin-bottom: 40px;
}
.g-auth-wechat .g-auth-wechat__qrcode {
  width: 146px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.g-auth-wechat .g-auth-wechat__tips {
  color: #444950;
  font-size: 12px;
  font-weight: 400;
}
.g-auth-wechat .g-auth-wechat__back-btn {
  color: #000;
  margin-top: 65px;
}
.g-auth-wechat .g-auth-wechat__mask {
  position: absolute;
  background: #000;
  opacity: 0.5;
  left: 10px;
  right: 10px;
  top: 10px;
  bottom: 10px;
}
.g-auth-wechat .g-auth-wechat__invalid-tips {
  color: #FFF;
  cursor: pointer;
  top: 80px;
  left: 30px;
  line-height: 20px;
  position: absolute;
  text-align: center;
  width: 134px;
  z-index: 100;
}
.g-auth-wechat .g-auth-wechat__message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 140px;
  line-height: 20px;
  font-size: 14px;
  border: 1px solid #DADDE1;
  color: #000;
  cursor: pointer;
}
.g-auth-wechat .g-auth-wechat__message .gdd-button {
  margin-top: 16px;
  padding: 0 16px;
  width: 90px;
}
.g-auth-wechat .g-auth-wechat__message .g-auth-wechat__tips {
  color: #8D949E;
  line-height: 16px;
}
.g-auth-wechat__message-error {
  margin-bottom: 8px;
}

</style>
